const EmptyList = () => {
  return <>Sin articulos</>
}

export default EmptyList